module.exports = __webpack_public_path__ + "./assets/logo_loading__5350bda8b7e6f0def37598fbe4a36667.png";